import { alpha, Box, Stack, Typography, useTheme } from "@mui/material";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import {
	REAL_ESTATE_TYPES,
	type RealEstateType,
} from "web_myplann/Portfolio/Forms/RealEstateForm/realEstateTypes";
import { FlatRowSelect } from "web_myplann/Shared/Components/FlatRow/FlatRowSelect";

type Props =
	| {
			mode: "select";
			value: RealEstateType;
			onChange: (value: RealEstateType) => void;
	  }
	| {
			mode: "locked";
			value: RealEstateType;
	  };

export const RealEstateTypeRow = (props: Props) => {
	const theme = useTheme();
	const { t } = useResource();

	const options = REAL_ESTATE_TYPES.map((value) => ({
		value,
		label: t(Resources.Portfolio.AddRealEstate.Types[value]),
	}));

	if (props.mode === "select") {
		return (
			<Box mt={0.8} bgcolor={theme.palette.background.paper}>
				<FlatRowSelect<RealEstateType>
					label={t(Resources.Portfolio.AddRealEstate.typeLabel)}
					drawerTitle={t(Resources.Portfolio.AddRealEstate.typeDrawerTitle)}
					value={props.value}
					options={options}
					onChange={props.onChange}
					isLast
				/>
			</Box>
		);
	}

	const lockedLabel = t(Resources.Portfolio.AddRealEstate.Types[props.value]);

	return (
		<Box mt={0.8} bgcolor={theme.palette.background.paper}>
			<Stack
				direction="row"
				alignItems="center"
				justifyContent="space-between"
				px={2}
				minHeight={48}
				borderBottom={`1px solid ${alpha(theme.palette.grey[100], 0.6)}`}
			>
				<Typography
					fontSize={14}
					color={theme.palette.grey[500]}
					flexShrink={0}
					mr={2}
				>
					{t(Resources.Portfolio.AddRealEstate.typeLabel)}
				</Typography>
				<Typography
					fontWeight={500}
					color={theme.palette.grey[400]}
					overflow="hidden"
					textOverflow="ellipsis"
					whiteSpace="nowrap"
				>
					{lockedLabel}
				</Typography>
			</Stack>
		</Box>
	);
};
